import * as R from 'ramda';

import sportsApi from '../../utils/sportsApi';

const getLeaguesAndFavorites = store => async state => {
    try {
        const userClientId = state.user.selectedUserClientId;
        const clientId = state.user.selectedClientId;

        // Sets filters as loading
        const loadingState = R.assocPath(
            [
                'clients',
                userClientId,
                'socialBenchmarking',
                'isLoadingFavorites',
            ],
            true,
            state,
        );

        store.setState(loadingState);

        const getFavorites = async () => {
            let favoritesLists = await sportsApi
                .url(`/clients/${clientId}/social-benchmarking/favorites`)
                .query({
                    includeAccountGroups: true,
                })
                .get()
                .json();

            if (favoritesLists.length === 0) {
                const newFavoritesList = await sportsApi
                    .url(`/clients/${clientId}/social-benchmarking/favorites`)
                    .json({
                        action: 'create',
                        domainObject: {
                            name: `favorites ${clientId}`,
                        },
                    })
                    .post()
                    .json();
                favoritesLists = [newFavoritesList];
            }

            const newFavoritesList = await Promise.all(
                favoritesLists.map(f =>
                    (async () => {
                        const resp = await sportsApi
                            .url(
                                `/clients/${clientId}/social-benchmarking/favorites/${f.id}/account-groups`,
                            )
                            .get()
                            .json();
                        return {
                            ...f,
                            favorites: resp,
                            accountTypeIds: [
                                ...new Set(resp.map(({ typeId }) => typeId)),
                            ],
                        };
                    })(),
                ),
            );
            return newFavoritesList;
        };

        const getLeagues = async () => {
            const leaguesWithoutTeams = await sportsApi
                .url(`/clients/${clientId}/benchmarking-leagues`)
                .query({
                    preselected: true,
                    includeAccountGroups: true,
                })
                .get()
                .json();

            const accountGroups = await sportsApi
                .url('/social-benchmarking/account-groups')
                .query({
                    leagueId: leaguesWithoutTeams.map(l => l.id),
                })
                .get()
                .json();

            const leagues = leaguesWithoutTeams.map(l => {
                const currentLeagueAccountGroups = accountGroups.filter(
                    ag => ag.leagueId === l.id,
                );

                return {
                    ...l,
                    accountGroups: currentLeagueAccountGroups,
                    accountTypeIds: [
                        ...new Set(
                            currentLeagueAccountGroups.map(
                                ({ typeId }) => typeId,
                            ),
                        ),
                    ],
                };
            });

            const orderedLeagues = leagues
                ? R.sortBy(R.prop('name'), leagues)
                : [];
            return orderedLeagues;
        };

        const [orderedLeagues, newFavoritesLists] = await Promise.all([
            getLeagues(),
            getFavorites(),
        ]);

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            socialBenchmarking: {
                                isLoadingLeagues: R.F,
                                leagues: R.always(orderedLeagues),
                                favoritesList: R.always(newFavoritesLists[0]),
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

export default getLeaguesAndFavorites;
